import { ReactNode, useCallback, useMemo, useState } from "react";
import { NavLink, useParams } from "react-router";
import { useBooleanFlagValue } from "@openfeature/react-sdk";
import t from "@/lang/lang";
import {
  SummariesTable,
  SummaryTableFilters,
  useDefaultCustomerHtzSummaryListRequest,
} from "@/services/backend/htz/summary/components/summaries-table";
import { Summary } from "@/services/backend/htz/summary/types/summary";
import { AlertNotReleased } from "@/shared/components/alerts/alert-not-released";
import { useActiveCompany } from "@/shared/lib/active-company/active-company-provider";
import { CustomerPageBreadcrumbs } from "../../_components/customer-page-breadcrumbs";
import {
  CustomerPageMain,
  CustomerPageMainContent,
  CustomerPageMainHeader,
} from "../../_components/customer-page";

export function CustomerHtzSummaryListRoute() {
  const isReleased = useBooleanFlagValue("gsm.htz.reports", true);
  const { customerId } = useParams();
  const { companyId } = useActiveCompany();

  const [request, setRequest] = useState(
    useDefaultCustomerHtzSummaryListRequest(companyId, customerId!),
  );

  const renderRowLink = useCallback((summary: Summary, children: ReactNode) => {
    // The backend requires every summary to belong to a process; the
    // portal Document type just declares processId optional.
    if (!summary.processId) return children;
    return (
      <NavLink
        to={`/processes/htz/${summary.processId}/summaries/${summary.id}`}
      >
        {children}
      </NavLink>
    );
  }, []);

  const breadcrumbs = useMemo(
    () => [
      {
        to: `/customers/${customerId}/htz/summaries`,
        label: t("HTZ"),
      },
      {
        to: `/customers/${customerId}/htz/summaries`,
        label: t("Inspektionsberichte"),
      },
    ],
    [customerId],
  );

  return (
    <CustomerPageMain>
      <CustomerPageMainHeader>
        <CustomerPageBreadcrumbs breadcrumbs={breadcrumbs} />
      </CustomerPageMainHeader>
      <CustomerPageMainContent className="gap-2">
        {!isReleased && <AlertNotReleased />}
        {isReleased && (
          <>
            <SummaryTableFilters
              request={request}
              onRequestChange={setRequest}
            />
            <SummariesTable
              request={request}
              onRequestChange={setRequest}
              renderRowLink={renderRowLink}
            />
          </>
        )}
      </CustomerPageMainContent>
    </CustomerPageMain>
  );
}
